'use strict';

var testEnabled = false;

let productGenderMap = {
    1: 'Woman',
    2: 'Man',
    3: 'Girl',
    4: 'Boy',
    5: 'Unisex',
    6: 'Baby'
};

let brandsMapping = {
    'CALZEDONIA': 'clz',
    'INTIMISSIMI': 'int',
    'TEZENIS': 'tzn',
    'FALCONERI': 'flc',
    'SIGNORVINO': 'sgv',
    'ATELIER_EME': 'eme'
};

var ListType = {
    'listing': {
        'class': 'category',
        'value': 'listing',
        'associatedObject': '.search-results'
    },
    'loyalty': {
        'class': 'loyalty',
        'value': 'loyalty',
        'associatedObject': '.suggested-for-you-section'
    },
    'wishlist': {
        'class': 'wishlistItemCards',
        'value': 'wishlist',
        'associatedObject': '.wishlistItemCards'
    },
    'search': {
        'class': 'search',
        'value': 'search',
        'associatedObject': '.search-results'
    },
    'completeYourLook': {
        'class': 'suggestedProducts, suggestedProductsMobile',
        'value': 'complete_your_look',
        'associatedObject': '.suggestedProductsContainer, .analyticsSuggestedProductsContainerMobile'
    },
    'completeThePromo': {
        'class': 'suggestedProductsPromo',
        'value': 'complete_the_promo',
        'associatedObject': '.suggestedProductsPromoContainer'
    },
    'completeThePromoMinicart': {
        'class': 'minicartSuggestedProducts',
        'value': 'complete_the_promo_minicart',
        'associatedObject': '.analyticsSuggestedProductsContainerMinicart'
    },
    'completeYourLookMinicart': {
        'class': 'minicartSuggestedProducts',
        'value': 'complete_your_look_minicart',
        'associatedObject': '.analyticsSuggestedProductsContainerMinicart'
    },
    'recentlyViewed': {
        'class': 'recentlyViewed',
        'value': 'recently_viewed',
        'associatedObject': '.recentlyViewedContainer'
    },
    'theMostPopular': {
        'class': 'theMostPopular',
        'value': 'the_most_popular',
        'associatedObject': '.theMostPopularContainer'
    },
    'filteredProducts': {
        'class': 'filteredProducts',
        'value': 'filter_applied',
        'associatedObject': '.filteredProducts'
    },
    'quizBras': {
        'class': 'quizBras',
        'value': 'quiz_bras',
        'associatedObject': '.quizBras'
    },
    'bestSellers': {
        'class': 'bestSellers',
        'value': 'best_sellers',
        'associatedObject': '.bestSellers'
    },
    'sortDecreasing': {
        'class': 'sortDecreasing',
        'value': 'sorting_decreasing_price',
        'associatedObject': '.sortDecreasing'
    },
    'sortIncreasing': {
        'class': 'sortIncreasing',
        'value': 'sorting_increasing_price',
        'associatedObject': '.sortIncreasing'
    },
    'sortDecreasingName': {
        'class': 'sortDecreasingName',
        'value': 'product_name_descending',
        'associatedObject': '.sortDecreasingName'
    },
    'sortIncreasingName': {
        'class': 'sortIncreasingName',
        'value': 'product_name_ascending',
        'associatedObject': '.sortIncreasingName'
    },
    'newArrivals': {
        'class': 'newArrivals',
        'value': 'new_arrivals',
        'associatedObject': '.newArrivals'
    },
    'js-youMayAlsoLike': {
        'class': 'js-youMayAlsoLike',
        'value': 'you_may_also_like',
        'associatedObject': '.js-youMayAlsoLikeContainer'
    },
    'js-orderAgain-carousel': {
        'class': 'orderAgainCarousel',
        'value': 'buy_it_again',
        'associatedObject': '.js-orderAgain-carousel'
    },
    'js-orderAgain-cartCarousel__list': {
        'class': 'orderAgainCartCarousel',
        'value': 'buy_it_again',
        'associatedObject': '.js-orderAgain-cartCarousel__list'
    },
    'cc-orderAgain-page__viewAllList': {
        'class': 'orderAgainAccountPage',
        'value': 'buy_it_again',
        'associatedObject': '.cc-orderAgain-page__viewAllList'
    },
    'analytics-orderAgain-seeSimilar': {
        'class': 'seeSimilar',
        'value': 'similar_products',
        'associatedObject': '.analytics-orderAgain-seeSimilar'
    },
    'analytics-order-details-page': {
        'class': 'orderDetailsPage',
        'value': 'buy_it_again',
        'associatedObject': '.js-orderDetails-products__container'
    }
};

function getProductGender (product) {
    if (product.sapCategoryCode) {
        let categoryCode = product.sapCategoryCode;
        return productGenderMap[parseInt(categoryCode[categoryCode.length - 1])];
    }
    return '';
}

function getTopLevelCategoryGender (formattedCategory) {
    if (!formattedCategory) {
        return '';
    }

    const splitCategories = formattedCategory.split('_');
    if (!splitCategories || splitCategories.length < 2) {
        return '';
    }

    const availableTopCategories = ['men', 'women', 'boys', 'girls', 'kids'];
    const category = splitCategories[1];
    if (availableTopCategories.includes(category)) {
        return category;
    }

    return '';
}

function getProductSustainability (product) {
    let sustainability = 'classic_item';
    if (product.customPromoLabel) {
        sustainability = product.customPromoLabel.match('TZN_DPM') ? 'sustainable_item' : 'classic_item';
    }
    return sustainability;
}

function insertParam (key, value) {
    key = encodeURI(key);
    value = encodeURI(value);

    var kvp = document.location.search.substr(1).split('&');

    var i = kvp.length;
    var x;
    while (i--) {
        x = kvp[i].split('=');

        if (x[0] === key) {
            x[1] = value;
            kvp[i] = x.join('=');
            break;
        }
    }

    if (i < 0) { kvp[kvp.length] = [key, value].join('='); }

    // this will reload the page, it's likely better to store this until finished
    document.location.search = kvp.join('&');
}

function hasParam (key) {
    key = encodeURI(key);

    return document.location.search.substr(1).indexOf(key) !== -1;
}

function getSkuCodes (sku) {
    let style = sku.substring(0, 9).trim();
    let color = sku.substring(9, 13).trim();
    let size = sku.substring(13).trim().replace('~', '/');
    return { id: style, color: color, size: size };
}

function formatStringForAnalytics (str) {
    return ('' + str).split(' ').join('_').toLowerCase().replace(/-/g, '_');
}

function getCatalogProductId (sku) {
    if (sku === null || typeof sku === 'undefined') {
        return '';
    }
    return ('' + sku).replace('_color_', ' ');
}

function formatStringProductPropertyIfExists (product, property, avoidFormatting = false) {
    if (product && property in product) {
        if (property === 'item_sfcc') {
            product[property] = getCatalogProductId(product[property]);
        } else if (property === 'parent_item_id' || property === 'parent_item_category4') {
            product[property] = '' + getFormatSkuForAnalytics(product[property]);
        } else if (avoidFormatting) {
            product[property] = '' + product[property];
        } else {
            product[property] = formatStringForAnalytics(product[property]);
        }
    }
    return product;
}

/* function formatStringProductPricePropertyIfExists (product, property, avoidFormatting = false) {
    if (property in product && product[property]) {
        if (avoidFormatting) {
            product[property] = '' + product[property].toString().replace(/\.(?=.*\.)/g, '');
        } else {
            product[property] = formatStringForAnalytics(product[property].toString().replace(/\.(?=.*\.)/g, ''));
        }
        if (product['discount'] && product['discount'] < 0) {
            product[property] = '0.00';
            product['discount'] = 0.00;
        }
    }
    return product;
} */

function formatStringProductSalePropertyIfExists (product, property, avoidFormatting = false) {
    if (product && property in product) {
        if (avoidFormatting) {
            product[property] = '' + product[property];
        } else {
            product[property] = formatStringForAnalytics(product[property]);
        }
        if (product['discount'] && parseFloat(product['discount'])) {
            product[property] = 'yes';
        }
    }
    return product;
}

function formatIntegerForAnalytics (value) {
    return parseInt(value);
}

function formatIntegerProductPropertyIfExists (product, property) {
    if (product && property in product) {
        product[property] = formatIntegerForAnalytics(product[property]);
    }
    return product;
}

function formatFloatProductPropertyIfExists (product, property) {
    if (product && property in product) {
        product[property] = (product[property] <= 0) ? 0.00 : parseFloat(product[property]);
    }
    return product;
}

function getFormatSkuForAnalytics (sku) {
    let id, color, size, formattedSku;
    if (sku.toLowerCase().indexOf('color') !== -1) { // variant group
        id = sku.split('_')[0].trim();
        color = sku.split('_')[2].trim();
        formattedSku = id + '_' + color;
    } else {
        if (sku.match('[^_]+_[^_]+_[^_]+')) {
            return sku.toUpperCase();
        }
        let skuComponents = getSkuCodes(sku);
        id = skuComponents.id;
        color = skuComponents.color;
        size = skuComponents.size;
        if (color && size) {
            formattedSku = id + '_' + color + '_' + size;
        } else { // master product
            formattedSku = id;
        }
    }
    return formattedSku.toUpperCase().replace(/_+/, '_');
}

function stringOrNotAvailable (s) {
    return (s !== null && typeof s !== 'undefined' && String(s)) || 'not_available';
}

function numberOrZero (n) {
    return parseFloat(n) || 0;
}

/* function notNullOrUndefined(v) {
    return v !== null && typeof v !== 'undefined';
} */

function getStringAnalyticsValueFromStorage (key) {
    return stringOrNotAvailable(window.sessionStorage.getItem(key));
}

function getNumberAnalyticsValueFromStorage (key) {
    return numberOrZero(window.sessionStorage.getItem(key));
}

module.exports = {

    isTestEnabled () {
        return testEnabled;
    },

    getAvailableListTypes (listingItemsBaseClass) {
        let types = [];

        for (let key in ListType) {
            if (ListType.hasOwnProperty(key)) {
                if ($(listingItemsBaseClass + '.' + ListType[key].class).length > 0) {
                    let item = ListType[key];
                    types.push(item);
                }
            }
        }

        return types;
    },

    getSkuComponents (sku) {
        return getSkuCodes(sku);
    },

    getProductGender (product) {
        return getProductGender(product);
    },

    getTopLevelCategoryGender (formattedCategory) {
        return getTopLevelCategoryGender(formattedCategory);
    },

    getProductBaseInfo (product) {
        let id = '';
        let color = '';
        let size = '';

        let colorObject = null;

        let promo = 'no_promotion';
        if ('promotions' in product && product.promotions) {
            promo = product.promotions.map(function (el) { return el.enabled ? el.id : null; }).filter(function (el) { return el !== null; }).join('-');
        } else if ('appliedPromotions' in product && product.appliedPromotions) {
            promo = product.appliedPromotions.map(function (el) { return el.name; }).join('-');
        }

        if (product.productType === 'variant') {
            let components = getSkuCodes(product.id);
            id = components.id;
            color = components.color;
            size = components.size;

            for (let k in product.variationAttributes) {
                const variationAttribute = product.variationAttributes[k];
                if (variationAttribute.attributeId === 'color') {
                    if ('values' in variationAttribute) {
                        for (let j in variationAttribute.values) {
                            if (variationAttribute.values[j].selected === true) {
                                colorObject = variationAttribute.values[j];
                                break;
                            }
                        }
                    } else {
                        colorObject = variationAttribute;
                    }
                    break;
                }
            }
        } else if (product.productType === 'variationGroup') {
            // in this case the user only chose the color, and not the size
            id = product.id.split('_')[0].trim();
            color = product.id.split('_')[2].trim();

            let selectedVariation;

            for (let k in product.variationAttributes) {
                const variationAttribute = product.variationAttributes[k];
                if (variationAttribute.attributeId === 'color') {
                    for (let j in variationAttribute.values) {
                        if (variationAttribute.values[j].selected === true) {
                            colorObject = variationAttribute.values[j];
                            break;
                        }
                    }
                }
                if (selectedVariation !== undefined) {
                    break;
                }
            }
        }

        return {
            id: id,
            color: color,
            colorObject: colorObject,
            size: size,
            promo: promo
        };
    },

    getProductSustainability (product) {
        return getProductSustainability(product);
    },

    formatProductForAnalytics (product) {
        product = formatStringProductPropertyIfExists(product, 'item_name');
        product = formatStringProductPropertyIfExists(product, 'item_brand');
        product = formatStringProductPropertyIfExists(product, 'item_variant', true);
        product = formatFloatProductPropertyIfExists(product, 'price');
        product = formatStringProductPropertyIfExists(product, 'item_category');
        product = formatIntegerProductPropertyIfExists(product, 'quantity');
        product = formatStringProductPropertyIfExists(product, 'size', true);
        product = formatStringProductSalePropertyIfExists(product, 'item_on_sale');
        product = formatStringProductPropertyIfExists(product, 'item_availability');
        product = formatStringProductPropertyIfExists(product, 'coupon');
        product = formatStringProductPropertyIfExists(product, 'item_color');
        product = formatStringProductPropertyIfExists(product, 'item_sfcc');
        product = formatStringProductPropertyIfExists(product, 'item_category2');
        product = formatStringProductPropertyIfExists(product, 'item_category3');
        product = formatStringProductPropertyIfExists(product, 'item_category4');
        product = formatStringProductPropertyIfExists(product, 'item_category5');
        product = formatStringProductPropertyIfExists(product, 'item_sustainable');
        product = formatStringProductPropertyIfExists(product, 'visualization_type');
        product = formatFloatProductPropertyIfExists(product, 'discount');
        product = formatStringProductPropertyIfExists(product, 'item_customization');
        product = formatStringProductPropertyIfExists(product, 'item_position_customization');
        product = formatStringProductPropertyIfExists(product, 'item_font_customization');
        product = formatStringProductPropertyIfExists(product, 'item_icon_customization');
        product = formatStringProductPropertyIfExists(product, 'item_color_customization');
        product = formatStringProductPropertyIfExists(product, 'item_text_customization');
        product = formatFloatProductPropertyIfExists(product, 'price_customization');
        product = formatStringProductPropertyIfExists(product, 'item_list_name');
        product = formatStringProductPropertyIfExists(product, 'item_list_id');
        product = formatStringProductPropertyIfExists(product, 'parent_item_id');
        product = formatStringProductPropertyIfExists(product, 'parent_item_category4');
        return product;
    },

    checkPage (str) {
        return window.location.href.toLowerCase().indexOf(str) !== -1;
    },

    // Formatting
    formatString (str) {
        return formatStringForAnalytics(str);
    },

    format4DigitNumber (number) {
        if (number < 0) {
            return '0000';
        } else if (number < 10) {
            return '000' + number;
        } else if (number < 100) {
            return '00' + number;
        } else if (number < 1000) {
            return '0' + number;
        }
        return number.toString();
    },

    // URL Parameters
    insertParameter (key, value) {
        insertParam(key, value);
    },
    existsParameter (key) {
        return hasParam(key);
    },

    // Push on DataLayer
    push (pushObject, log = true) {
        // eslint-disable-next-line
        dataLayer.push(pushObject);

        if (log && testEnabled) {
            console.info(pushObject);
        }
    },

    log (data, inline = false) {
        if (!testEnabled) {
            return;
        }
        if (inline) {
            console.info('Analytics: ' + data);
        } else {
            console.info('Analytics: ');
            console.info(data);
        }
    },

    getFormatSku (sku) {
        return getFormatSkuForAnalytics(sku);
    },

    getCatalogProductId (sku) {
        return getCatalogProductId(sku);
    },

    formatSkus (skus) {
        let formattedSkus = '';
        for (let i = 0; i < skus.length; i++) {
            let formattedSku = getFormatSkuForAnalytics(skus[i]).replace(/\W/g, '_');
            if (i === 0) {
                formattedSkus += formattedSku;
            } else {
                formattedSkus += '-' + formattedSku;
            }
        }
        return formattedSkus;
    },

    formatNameForAnalytics (name) {
        if (!name) {
            return '';
        }
        let formattedPlus = name.toLowerCase().replace(/[+]/g, '_plus_');
        let formattedName = formattedPlus.replace(/\W/g, '_');
        let analyticsName = formattedName.split('_').filter((el) => { return el; }).join('_');
        return analyticsName;
    },

    getFormatedNewsletterPreferenceBrands (list) {
        let brandsStr = '';
        for (let brand of list) {
            brandsStr += brandsMapping[brand] + '-';
        }

        brandsStr = brandsStr.substring(0, brandsStr.length - 1);

        return brandsStr;
    },

    getListId (container, provider) {
        let list = '';
        if (container && ($(container).parents('.analytics-mini-cart').length || $(container).parents('.feedback-cart-container').length)) {
            list = 'minicart';
        } else if ($('.page[data-action="Search-Show"]').length) {
            list = 'plp';
        } else if ($('.page[data-action="Product-Show"]').length) {
            list = 'pdp';
        } else if ($('.page[data-action="Home-Show"]').length) {
            list = 'home';
        } else if ($('.page[data-action="Cart-Show"]').length) {
            list = 'cart';
        } else if ($('.page[data-action="Wishlist-Show"]').length) {
            list = 'wishlist';
        } else if ($('.page[data-action="Order-History"]').length || $('.page[data-action="OrderAgain-ShowAccount"]').length || $('.page[data-action="Order-Details"]').length) {
            list = 'my_orders_and_returns';
        } else if ($('.page[data-action="OrderAgain-SeeSimilar"]').length) {
            list = 'my_orders_and_returns';
        }

        if (list && provider && (list === 'pdp' || list === 'home' || list === 'cart')) {
            list = `${provider}_${list}`;
        }
        return list;
    },

    getProductList () {
        let items = [];
        let container = $('.analytics.checkout.checkout-product');

        for (let i = 0; i < container.length; i++) {
            let obj = container.eq(i).data();
            if (obj.id !== 'PERS_PROD') {
                obj['quantity'] = obj.quantity;
                items.push(this.formatProductForAnalytics(obj));
            }
        }
        return items;
    },

    getGrandTotal () {
        return parseFloat($('.analytics-totals').data('grand-total'));
    },

    getAppliedCoupon () {
        const coupon = [];
        $('#couponCode.coupon-code-field--applied').val() && coupon.push($('#couponCode.coupon-code-field--applied').val());
        $('.analytics-shipping-discount').length && coupon.push('shipping_discount');
        $('.analytics-order-discount').length && coupon.push('order_discount');
        return coupon.join(',');
    },

    getUpsellingMessage () {
        let upsellingMessage = localStorage.getItem('upsellingMessage') || 'no_message';
        if ($('.page').data('action') === 'Cart-Show') {
            const vals = [];
            $('.analytics-message').each(function () {
                if (vals.indexOf($(this).data('analytics-type')) === -1) {
                    vals.push($(this).data('analytics-type'));
                }
            });
            if (vals.length > 0) {
                upsellingMessage = vals.join('-');
                localStorage.setItem('upsellingMessage', upsellingMessage);
            }
        }
        return upsellingMessage;
    },

    getBeginCheckoutData (context) {
        return {
            upselling_message: this.getUpsellingMessage(),
            currency: context.helperData.currency,
            value: this.getGrandTotal(),
            coupon: this.getAppliedCoupon(),
            items: this.getProductList()
        };
    },

    getSortingType (sortingContainer) {
        var sortingSelected = sortingContainer.getAttribute('id');
        var formattedSorting = '';
        if (sortingSelected === 'price-low-to-high') {
            formattedSorting = 'sorting_increasing_price';
        } else if (sortingSelected === 'price-high-to-low') {
            formattedSorting = 'sorting_decreasing_price';
        } else if (sortingSelected === 'top_sellers') {
            formattedSorting = 'best_sellers';
        } else {
            formattedSorting = sortingSelected.replaceAll('-', '_');
        }
        return formattedSorting;
    },
    storeGtmData (data) {
        if (data && data.item_list_name && data.item_list_id && (data.index || data.index === 0)) {
            if (data.item_id && data.item_variant) {
                window.sessionStorage.setItem('GTM_' + data.item_id + '_color_' + data.item_variant, JSON.stringify({'item_list_name': data.item_list_name, 'item_list_id': data.item_list_id, 'index': data.index}));
            }
            // Adding values for color change event
            window.sessionStorage.setItem('GTM_item_list_name', data.item_list_name);
            window.sessionStorage.setItem('GTM_item_list_id', data.item_list_id);
            window.sessionStorage.setItem('GTM_index', data.index);
        }
    },
    getGtmData (data) {
        const GTMData = {};
        if (data && data.item_id && data.item_variant) {
            const GTMItem = JSON.parse(window.sessionStorage.getItem('GTM_' + data.item_id + '_color_' + data.item_variant)) || {};
            GTMData.item_list_name = stringOrNotAvailable(GTMItem.item_list_name);
            GTMData.item_list_id = stringOrNotAvailable(GTMItem.item_list_id);
            GTMData.index = numberOrZero(GTMItem.index);
        } else {
            GTMData.item_list_name = getStringAnalyticsValueFromStorage('GTM_item_list_name');
            GTMData.item_list_id = getStringAnalyticsValueFromStorage('GTM_item_list_id');
            GTMData.index = getNumberAnalyticsValueFromStorage('GTM_index');
        }
        return GTMData;
    },
    setBonusProductData ($container, index) {
        $container.data('item_list_name', 'free_product');
        $container.data('item_list_id', this.getListId());
        $container.data('index', index);
        $container.data('discount', $container.data('price'));
        $container.data('price', 0);
    },
    mapPosition () {
        const controller = $('.page').data('action').toLowerCase();

        const map = {
            'digitalwallet-show': 'from_my_wallet'
        };

        return map[controller] || null;
    },
    getTypeOfAccount () {
        let typeOfAccount = 'only_registration';
        if ($('.loyaltyFlag:checked, .loyalty-flag:checked').length === 1) {
            typeOfAccount = 'profile_loyalty';
        }
        return typeOfAccount;
    }
};
